import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import Button from '@components/Button'

import { Dropdown } from '@components/Form/Autocomplete'
import yup from 'yup'


class EYComplianceDialog extends Component {

    static propTypes = {
      staticData: PropTypes.object,
      modalStore: PropTypes.object,

      growlStore: PropTypes.object,
      actionAfterSubmit: PropTypes.func
    }

    constructor(props) {
      super(props)
      this.state = {}
    }

    validationSchema=yup.object().shape({
      flagForCompliance: yup.boolean().required("Required"),
      completedAllComplianceQuestions: yup.boolean().required("Required"),
    })


    handleSubmit = (value, actions) => {
      actions.setSubmitting(true)
      const { modalStore  } = this.props
      const {actionAfterSubmit} = this.props
      actionAfterSubmit && actionAfterSubmit(value)
      modalStore.close()
      actions.setSubmitting(false)
    }

    render(){
      const { modalStore } = this.props
      return (
        <Formik
          initialValues={{ }}
          onSubmit={this.handleSubmit}
          validationSchema={this.validationSchema}
          render={form => (

          <div className='expert-form'>
            <h1 className='expert-form__title'>
              EY Compliance Review
            </h1>
              <Form onSubmit={form.handleSubmit}>
                <div className='expert-form__section'>
                <p>
                  Has the expert replied YES to any of the compliance screening questions?
                </p>
                <div style={{maxWidth: 150}}>
                  <Field
                    name='flagForCompliance'
                    itemToString={i => (i && i.label) || ''}
                    component={Dropdown}
                    options={[{label:'Yes', id:true},{label:'No',id:false}]}
                  />
                </div>
                </div>
                <div className='expert-form__section'>
                  <p>
                    Has the expert completed all the compliance screening questions?
                  </p>
                  <div style={{maxWidth: 150}}>
                    <Field
                      name='completedAllComplianceQuestions'
                      itemToString={i => (i && i.label) || ''}
                      component={Dropdown}
                      options={[{label:'Yes', id:true},{label:'No',id:false}]}
                    />
                  </div>
                </div>
                <div className='expert-form__section'>
                  <Button
                    primary
                    submit
                    onClick={this.onSubmit}
                    disabled={form.isSubmitting}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={modalStore.close}
                    disabled={form.isSubmitting}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
          </div>

            )}
        />
      )
    }
}

EYComplianceDialog.defaultProps = {
  hideButtons: true,
  showCloseIcon: true,
  shouldCloseOnOverlayClick: false
}

export default withRouter(
  inject(
    'staticData',
    'modalStore',
    'growlStore'
  )(observer(EYComplianceDialog)))
